import { messages as contractCreateFeeMessages } from '../views/fee/contractCreateFeeLang'
import { messages as meterWaterManageMessages } from '../views/fee/meterWaterManageLang'
import { messages as meterTypeManageMessages } from '../views/fee/meterTypeManageLang'
import { messages as returnPayFeeManageMessages } from '../views/fee/returnPayFeeManageLang'
import { messages as feeDiscountManageMessages } from '../views/fee/feeDiscountManageLang'
import { messages as applyRoomDiscountManageMessages } from '../views/fee/applyRoomDiscountManageLang'
import { messages as discountTypeMessages } from '../views/fee/discountTypeLang'
import { messages as listApplyRoomDiscountRecordMessages } from '../views/fee/listApplyRoomDiscountRecordLang'
import { messages as feeReceiptMessages } from '../views/fee/feeReceiptLang'
import { messages as printPayFeeMessages } from '../views/fee/printPayFeeLang'
import { messages as printPayFeeBangTaiMessages } from '../views/fee/printPayFeeBangTaiLang'
import { messages as printSmallPayFeeMessages } from '../views/fee/printSmallPayFeeLang'
import { messages as floorShareMessages } from '../views/fee/floorShareLang'
import { messages as shareReadingMessages } from '../views/fee/shareReadingLang'
import { messages as roomFeeImportMessages } from '../views/fee/roomFeeImportLang'
import { messages as shareReadingFeeMessages } from '../views/fee/shareReadingFeeLang'
import { messages as payFeeBatchMessages } from '../views/fee/payFeeBatchLang'
import { messages as oweFeeCallableMessages } from '../views/fee/oweFeeCallableLang'
import { messages as addOweFeeCallableMessages } from '../views/fee/addOweFeeCallableLang'
import { messages as roomCreateFeeMessages } from '../views/fee/roomCreateFeeLang.js'
import { messages as propertyFeeMessages } from '../views/fee/propertyFeeLang'
import { messages as batchPayFeeOrderMessages } from '../views/fee/batchPayFeeOrderLang'
import { messages as simplifyAcceptanceMessages } from '../views/simplify/simplifyAcceptanceLang.js'
import { messages as payFeeOrderMessages } from '../views/fee/payFeeOrderLang'
import { messages as refundDepositFeeMessages } from '../views/fee/refundDepositFeeLang'
import { messages as createFeeByComboMessages } from '../views/fee/createFeeByComboLang'
import { messages as feeComboManageMessages } from '../views/fee/feeComboManageLang'
import { messages as owePayFeeOrderMessages } from '../views/fee/owePayFeeOrderLang'
import { messages as printOweFeeMessages } from '../views/fee/printOweFeeLang'
import { messages as feeDetailMessages } from '../views/fee/feeDetailLang'
import { messages as roomCreatePayFeeMessages } from '../views/fee/roomCreatePayFeeLang'
import { messages as printAccountReceiptMessages } from '../views/account/printAccountReceiptLang'
import { messages as printSmallAccountReceiptMessages } from '../views/account/printSmallAccountReceiptLang'
import { messages as listApplyRoomDiscountRecordDetailsMessages } from '../views/fee/listApplyRoomDiscountRecordDetailsLang'
import { messages as roomOweFeeCallableMessages } from '../views/fee/roomOweFeeCallableLang'
import { messages as prePayFeeOrderMessages } from '../views/fee/prePayFeeOrderLang'
import { messages as prePayFeeDeductionDetailMessages } from '../views/fee/prePayFeeDeductionDetailLang'
import { messages as refundPrePayFeeMessages } from '../views/fee/refundPrePayFeeLang'
import { messages as wirteRuleFeeRemarkMessages } from '../views/fee/wirteRuleFeeRemarkLang'
import { messages as shopCreateFeeMessages } from '../views/fee/shopCreateFeeLang'
import { messages as miscFeeCreateMessages } from '../views/fee/miscFeeCreateLang'

export const messages = {
    en: {
        ...contractCreateFeeMessages.en,
        ...meterWaterManageMessages.en,
        ...meterTypeManageMessages.en,
        ...returnPayFeeManageMessages.en,
        ...feeDiscountManageMessages.en,
        ...applyRoomDiscountManageMessages.en,
        ...discountTypeMessages.en,
        ...listApplyRoomDiscountRecordMessages.en,
        ...feeReceiptMessages.en,
        ...printPayFeeMessages.en,
        ...printPayFeeBangTaiMessages.en,
        ...printSmallPayFeeMessages.en,
        ...floorShareMessages.en,
        ...shareReadingMessages.en,
        ...roomFeeImportMessages.en,
        ...shareReadingFeeMessages.en,
        ...payFeeBatchMessages.en,
        ...oweFeeCallableMessages.en,
        ...addOweFeeCallableMessages.en,
        ...roomCreateFeeMessages.en,
        ...propertyFeeMessages.en,
        ...batchPayFeeOrderMessages.en,
        ...simplifyAcceptanceMessages.en,
        ...payFeeOrderMessages.en,
        ...refundDepositFeeMessages.en,
        ...createFeeByComboMessages.en,
        ...feeComboManageMessages.en,
        ...owePayFeeOrderMessages.en,
        ...printOweFeeMessages.en,
        ...feeDetailMessages.en,
        ...roomCreatePayFeeMessages.en,
        ...printAccountReceiptMessages.en,
        ...printSmallAccountReceiptMessages.en,
        ...listApplyRoomDiscountRecordDetailsMessages.en,
        ...roomOweFeeCallableMessages.en,
        ...prePayFeeOrderMessages.en,
        ...prePayFeeDeductionDetailMessages.en,
        ...refundPrePayFeeMessages.en,
        ...wirteRuleFeeRemarkMessages.en,
        ...shopCreateFeeMessages.en,
        ...miscFeeCreateMessages.en,
    },
    zh: {
        ...contractCreateFeeMessages.zh,
        ...meterWaterManageMessages.zh,
        ...meterTypeManageMessages.zh,
        ...returnPayFeeManageMessages.zh,
        ...feeDiscountManageMessages.zh,
        ...applyRoomDiscountManageMessages.zh,
        ...discountTypeMessages.zh,
        ...listApplyRoomDiscountRecordMessages.zh,
        ...feeReceiptMessages.zh,
        ...printPayFeeMessages.zh,
        ...printPayFeeBangTaiMessages.zh,
        ...printSmallPayFeeMessages.zh,
        ...floorShareMessages.zh,
        ...shareReadingMessages.zh,
        ...roomFeeImportMessages.zh,
        ...shareReadingFeeMessages.zh,
        ...payFeeBatchMessages.zh,
        ...oweFeeCallableMessages.zh,
        ...addOweFeeCallableMessages.zh,
        ...roomCreateFeeMessages.zh,
        ...propertyFeeMessages.zh,
        ...batchPayFeeOrderMessages.zh,
        ...simplifyAcceptanceMessages.zh,
        ...payFeeOrderMessages.zh,
        ...refundDepositFeeMessages.zh,
        ...createFeeByComboMessages.zh,
        ...feeComboManageMessages.zh,
        ...owePayFeeOrderMessages.zh,
        ...printOweFeeMessages.zh,
        ...feeDetailMessages.zh,
        ...roomCreatePayFeeMessages.zh,
        ...printAccountReceiptMessages.zh,
        ...printSmallAccountReceiptMessages.zh,
        ...listApplyRoomDiscountRecordDetailsMessages.zh,
        ...roomOweFeeCallableMessages.zh,
        ...prePayFeeOrderMessages.zh,
        ...prePayFeeDeductionDetailMessages.zh,
        ...refundPrePayFeeMessages.zh,
        ...wirteRuleFeeRemarkMessages.zh,
        ...shopCreateFeeMessages.zh,
        ...miscFeeCreateMessages.zh,
    },
    'zh-TW': {
        ...contractCreateFeeMessages['zh-TW'],
        ...meterWaterManageMessages['zh-TW'],
        ...meterTypeManageMessages['zh-TW'],
        ...returnPayFeeManageMessages['zh-TW'],
        ...feeDiscountManageMessages['zh-TW'],
        ...applyRoomDiscountManageMessages['zh-TW'],
        ...discountTypeMessages['zh-TW'],
        ...listApplyRoomDiscountRecordMessages['zh-TW'],
        ...feeReceiptMessages['zh-TW'],
        ...printPayFeeMessages['zh-TW'],
        ...printPayFeeBangTaiMessages['zh-TW'],
        ...printSmallPayFeeMessages['zh-TW'],
        ...floorShareMessages['zh-TW'],
        ...shareReadingMessages['zh-TW'],
        ...roomFeeImportMessages['zh-TW'],
        ...shareReadingFeeMessages['zh-TW'],
        ...payFeeBatchMessages['zh-TW'],
        ...oweFeeCallableMessages['zh-TW'],
        ...addOweFeeCallableMessages['zh-TW'],
        ...roomCreateFeeMessages['zh-TW'],
        ...propertyFeeMessages['zh-TW'],
        ...batchPayFeeOrderMessages['zh-TW'],
        ...simplifyAcceptanceMessages['zh-TW'],
        ...payFeeOrderMessages['zh-TW'],
        ...refundDepositFeeMessages['zh-TW'],
        ...createFeeByComboMessages['zh-TW'],
        ...feeComboManageMessages['zh-TW'],
        ...owePayFeeOrderMessages['zh-TW'],
        ...printOweFeeMessages['zh-TW'],
        ...feeDetailMessages['zh-TW'],
        ...roomCreatePayFeeMessages['zh-TW'],
        ...printAccountReceiptMessages['zh-TW'],
        ...printSmallAccountReceiptMessages['zh-TW'],
        ...listApplyRoomDiscountRecordDetailsMessages['zh-TW'],
        ...roomOweFeeCallableMessages['zh-TW'],
        ...prePayFeeOrderMessages['zh-TW'],
        ...prePayFeeDeductionDetailMessages['zh-TW'],
        ...refundPrePayFeeMessages['zh-TW'],
        ...wirteRuleFeeRemarkMessages['zh-TW'],
        ...shopCreateFeeMessages['zh-TW'],
        ...miscFeeCreateMessages['zh-TW'],
    }
}
